module.exports = __webpack_public_path__ + "static/media/info.e8472bdb.svg";